import {
  Box,
  Center,
  Text,
} from "@chakra-ui/react";
import LineSection from "../lineSection";
import SectionHeading from "./sectionHeading";
import Lang from "../../Lang";

export default function Background() {
  return (
    <>
      <LineSection />
      <Box
        color='white'
      >
        <Box
          pt={5}
          className="opacityTop opacityDown"
        >
          <Center>
            <Box
              w={{ base: "full", md: "4xl", xl: "6xl" }}
              pt={{ base: 10 }}
            >
              <SectionHeading
                title="Background"
              />
            </Box>
          </Center>
        </Box>

        <Box className="opacityBottom">
          <Center>
              <Box
                w={{ base: "full", md: "3xl", xl: "6xl" }}
              >
                <Text
                  pt={10}
                  pb={10}
                  px={{ base: 4, md: 6 }}
                  fontSize={{ base: "1.3em", md: "1.5em",lg:"1.7",xl:"2em" }}
                >
                  <Lang text="We are aware of the difficulties faced by young people from low-income countries in accessing and completing an educational program without limitations." />
                </Text>

                <Text
                  pb={10}
                  px={{ base: 4, md: 6 }}
                  fontSize={{ base: "1.3em", md: "1.5em",lg:"1.7",xl:"2em" }}
                >
                  <Lang text="Most of these young students end up leaving the classroom to go to work and help their parents, because their family does not have enough income and resources." />
                </Text>

                <Text
                  pb={10}
                  px={{ base: 4, md: 6 }}
                  fontSize={{ base: "1.3em", md: "1.5em",lg:"1.7",xl:"2em" }}
                >
                  <Lang text="There are small groups of children led by teachers, who try to foster curiosity for robotics and programming languages, but they or their institutions do not have the budget to support these initiatives." />
                </Text>

                <Text
                  pb={10}
                  px={{ base: 4, md: 6 }}
                  fontSize={{ base: "1.3em", md: "1.5em",lg:"1.7",xl:"2em" }}
                >
                  <Lang text="Children dream of a future where they use technology to solve problems and improve the environment in their communities, but they don't know how to make those dreams a reality." />
                </Text>

                <Text
                  pb={{base:20,md:40}}
                  px={{ base: 4, md: 6 }}
                  fontSize={{ base: "1.3em", md: "1.5em",lg:"1.7",xl:"2em" }}
                >
                  <Lang text="We can help overcome these difficulties and provide opportunities to continue dreaming and building a better future." />
                </Text>
              </Box>
          </Center>
        </Box>
      </Box>
    </>
  );
}